export default __webpack_public_path__ + "51efe4094f491117fb5c799fef513210.svg";